import React, { useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { handlePatchRequest } from '../../../service/PatchTemplate';
import { endPoints } from '../../../Config';

const UpdatePassword = ({ profileInfo, onClose, onHide }) => {
    const [loadingBtn, setLoadingBtn] = useState(false);

    const dispatch = useDispatch();

    const validationSchema = Yup.object().shape({
        oldPassword: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .required('This field is required'),
        newPassword: Yup.string()
            .required('New password is required')
            .matches(/^\S.*\S$|^\S$/, 'Leading and trailing spaces are not allowed')
            .min(8, 'Password must be at least 8 characters')
            .max(20, 'Password must not exceed 20 characters')
            .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
            .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
            .matches(/[0-9]/, 'Password must contain at least one number')
            .matches(/[@$!%*?&]/, 'Password must contain at least one special character (@, $, !, %, *, ?, &)')
            .notOneOf([Yup.ref('oldPassword')], 'New password must be different from old password')
    });

    const formik = useFormik({
        validationSchema,
        initialValues: {
            newPassword: '',
            oldPassword: ''
        },
        onSubmit: async (data) => {
            const user = JSON.parse(localStorage.getItem('adminUser') || '{}');

            setLoadingBtn(true);
            const passwordData = {
                userId: profileInfo?.id,
                oldPassword: data?.oldPassword,
                newPassword: data?.newPassword,
                modifiedBy: user?.data?.userId
            };

            const response = await dispatch(handlePatchRequest(passwordData, endPoints.changePassword, true));
            if (response?.status === 200) {
                formik.resetForm();
                onHide();
            }
            setLoadingBtn(false);
        }
    });

    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="grid p-fluid">
                <div className="col-8 md:col-3"></div>
                <div className="col-8 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="oldPassword">
                            Old Password <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText id="oldPassword" name="oldPassword" placeholder="Enter Old Password" value={formik?.values?.oldPassword} maxLength={30} onChange={formik.handleChange} />
                        {formik.touched.oldPassword && formik.errors.oldPassword && <small className="p-error">{formik.errors.oldPassword}</small>}
                    </div>
                </div>
                <div className="col-8 md:col-3"></div>
                <div className="col-8 md:col-3"></div>
                <div className="col-8 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="newPassword">
                            Old Password <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText id="newPassword" name="newPassword" placeholder="Enter Old Password" value={formik?.values?.newPassword} maxLength={30} onChange={formik.handleChange} />
                        {formik.touched.newPassword && formik.errors.newPassword && <small className="p-error">{formik.errors.newPassword}</small>}
                    </div>
                </div>
                <div className="col-8 md:col-3"></div>
            </div>

            <div className="flex justify-content-center mt-4 gap-2">
                <Button label={'Update'} icon={'pi pi-pencil'} type="submit" disabled={loadingBtn} className="p-button-success p-button-sm" style={{ minWidth: 90, maxWidth: 120, width: 'auto' }} />
                <Button label="Cancel" icon="pi pi-times" type="button" className="p-button-secondary p-button-sm" style={{ minWidth: 90, maxWidth: 120, width: 'auto' }} onClick={() => onClose()} />
            </div>
        </form>
    );
};

export default UpdatePassword;
